import React, { SetStateAction } from 'react';

import { Box } from '@mui/material';

import {
  RecipePresetSubstep,
  settingsInterface,
} from '../../../app/recipeCreation/createRecipe.types';
import PresetSelectedView from './PresetSelectedView';
import PresetsView from './PresetsView';

const Presets = ({
  isPresetOpen,
  setIsPresetOpen,
  settings,
  setSettings,
  presetSelected,
  setPresetSelected,
  presetsData,
}: {
  isPresetOpen: boolean;
  setIsPresetOpen: React.Dispatch<SetStateAction<boolean>>;
  settings: Array<settingsInterface>;
  setSettings: React.Dispatch<SetStateAction<Array<settingsInterface>>>;
  presetSelected: RecipePresetSubstep | null;
  setPresetSelected: React.Dispatch<SetStateAction<RecipePresetSubstep | null>>;
  presetsData: any;
}) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
    }}
  >
    {presetSelected === null ? (
      <PresetsView
        isPresetOpen={isPresetOpen}
        presetSelected={presetSelected}
        setIsPresetOpen={setIsPresetOpen}
        setPresetSelected={setPresetSelected}
        setSettings={setSettings}
        settings={settings}
        presetsData={presetsData}
      />
    ) : (
      <PresetSelectedView
        isPresetOpen={isPresetOpen}
        presetSelected={presetSelected}
        setIsPresetOpen={setIsPresetOpen}
        setPresetSelected={setPresetSelected}
        setSettings={setSettings}
        settings={settings}
      />
    )}
  </Box>
);

export default Presets;
